import { Box, Button, Divider, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { isNotEmpty } from "../../Utils";
import CustomDatePicker from "../../component/CustomDatePicker/CustomDatePicker";
import FormBox from "../../component/FormBox/FormBox";
import CustomCheckBox from "../../inputComponent/CustomCheckBox/CustomCheckBox";
import AlertDialog from "../AlertDialog/AlertDialog";
import DailyStatistics from "./ParameterTemplate101/DailyStatistics";
import SubjectTable from "./ParameterTemplate101/SubjectTable";
const useStyles = makeStyles({
    isPublish: {
        position: "absolute",
        right: "70px",
    },
    container: {
        maxHeight: 250,
    },
    label: {
        paddingRight: 10,
        paddingTop: 6,
    },
    dateLabel: {
        paddingRight: 10,
        paddingTop: 5,
    },
    removeBtn: {
        position: "absolute",
        right: "10px",
        bottom: "10px",
    },
    headBorder: {
        borderTop: "1px solid #ccc",
    },
    subjectTableContainer: {
        position: "relative",
        paddingTop: "30px",
        marginTop: "10px",
        maxHeight: "800px",
    },
    subjectTableTitle: {
        position: "sticky",
        right: "10px",
    },
    subjectTable: {
        tableLayout: "fixed",
        padding: "5px",
    },
    subjectRow: {
        padding: "0px 15px",
    },
    blodText: {
        fontWeight: "bold",
    },
    reviewerSelect: {
        width: "100%",
    },
    disable: {
        pointerEvents: "none",
        opacity: ".5",
        color: "grey",
    },
    headNotBorder: {
        border: "none",
        backgroundColor: "#fff",
    },
});

function ParameterTemplate101({
    defaultValues,
    register,
    control,
    errors,
    getValues,
    setValue,
    trigger,
    reviewerList,
}) {
    const classes = useStyles();
    const { t, i18n } = useTranslation();

    const dispatch = useDispatch();

    const [disableArr, setDisableArr] = useState([]);
    const [disablePostAddBtn, setDisablePostAddBtn] = useState(false);
    const [duplicatePublishJobText, setDuplicatePublishJobText] = useState("");
    const [duplicatePublishJobDialog, setDuplicatePublishJobDialog] =
        useState(false);

    const jobFieldArray = useFieldArray({
        control,
        name: "job",
    });

    const handleRemoveList = (index) => {
        jobFieldArray.remove(index);
    };

    const handleAppendList = () => {
        jobFieldArray.append(
            {
                startDate: "",
                endDate: "",
                jobTitle: "",
                isPublish: false,
                subjectList: [
                    {
                        subjectName: "",
                        hasEnglish: false,
                        hasAEO: false,
                        hasMath: false,
                        hasPutonghua: false,
                    },
                ],
                reviewerList: [
                    {
                        post: "",
                        interfaceUsername: "",
                        email: "",
                    },
                ],
            },
            { shouldFocus: false }
        );
    };

    useEffect(() => {
        let newArr = [];
        jobFieldArray.fields.map(
            (job, jobIndex) => (newArr[jobIndex] = job.isPublish ? true : false)
        );
        setDisableArr(newArr);

        const optionsList = getValues(
            `jobApplication${i18n.language?.toUpperCase()}`
        );
        const initJobOptions = optionsList?.jobOptions || {};
        const initJobOptionsKeys = Object.keys(initJobOptions);
        const isAllJobInput = initJobOptionsKeys?.every((jobKey) =>
            jobFieldArray?.fields?.find((job) => job?.jobTitle === jobKey)
        );
        setDisablePostAddBtn(isAllJobInput);
    }, [jobFieldArray.fields]);

    return (
        <>
            <FormBox>
                <Box p={5}>
                    {jobFieldArray.fields.map((job, jobIndex) => {
                        return (
                            <FormBox
                                key={job?.id}
                                className={
                                    disableArr[jobIndex] ? classes.disable : ""
                                }
                            >
                                <Box
                                    p={5}
                                    style={{
                                        position: "relative",
                                        paddingBottom: "60px",
                                    }}
                                    className={getValues(
                                        `job.${jobIndex}.isPublish`
                                    )}
                                >
                                    <Box mt={4}>
                                        <Grid container>
                                            <Grid
                                                item
                                                xs={2}
                                                className={
                                                    disableArr[jobIndex]
                                                        ? classes.disable
                                                        : ""
                                                }
                                            >
                                                {t(
                                                    "Form101.label.jobPeriodStart"
                                                ) + t("common.colon")}
                                            </Grid>
                                            <Grid item xs={3}>
                                                <CustomDatePicker
                                                    className={
                                                        disableArr[jobIndex]
                                                            ? classes.disable
                                                            : ""
                                                    }
                                                    control={control}
                                                    name={`job.${jobIndex}.startDate`}
                                                    inputProps={{
                                                        ...register(
                                                            `job.${jobIndex}.startDate`,
                                                            {
                                                                required:
                                                                    t(
                                                                        "errorMsg.required"
                                                                    ),
                                                                validate: {
                                                                    earlierThanEnd:
                                                                        (
                                                                            date
                                                                        ) => {
                                                                            const endData =
                                                                                getValues(
                                                                                    `job.${jobIndex}.endDate`
                                                                                );
                                                                            return (
                                                                                isNotEmpty(
                                                                                    endData
                                                                                ) &&
                                                                                (moment(
                                                                                    endData
                                                                                ).diff(
                                                                                    moment(
                                                                                        date
                                                                                    ),
                                                                                    "days"
                                                                                ) >=
                                                                                    0 ||
                                                                                    t(
                                                                                        "errorMsg.date.beforeThisDate",
                                                                                        {
                                                                                            targetDate: `${moment(
                                                                                                endData
                                                                                            ).format(
                                                                                                "DD/MM/YYYY"
                                                                                            )}`,
                                                                                        }
                                                                                    ))
                                                                            );
                                                                        },
                                                                },
                                                            }
                                                        ),
                                                    }}
                                                    type="dateTime"
                                                    dateFormat="dd/MM/yyyy h:mm aa"
                                                    onChange={() => {
                                                        trigger([
                                                            `job.${jobIndex}.startDate`,
                                                            `job.${jobIndex}.endDate`,
                                                        ]);
                                                    }}
                                                    minDate={new Date()}
                                                />
                                            </Grid>
                                            <Grid item xs={1}></Grid>
                                            <Grid
                                                item
                                                xs={2}
                                                className={
                                                    disableArr[jobIndex]
                                                        ? classes.disable
                                                        : ""
                                                }
                                            >
                                                {t(
                                                    "Form101.label.jobPeriodEnd"
                                                ) + t("common.colon")}
                                            </Grid>
                                            <Grid item xs={3}>
                                                <CustomDatePicker
                                                    className={
                                                        disableArr[jobIndex]
                                                            ? classes.disable
                                                            : ""
                                                    }
                                                    control={control}
                                                    name={`job.${jobIndex}.endDate`}
                                                    inputProps={{
                                                        ...register(
                                                            `job.${jobIndex}.endDate`,
                                                            {
                                                                required:
                                                                    t(
                                                                        "errorMsg.required"
                                                                    ),
                                                                validate: {
                                                                    laterThanStart:
                                                                        (
                                                                            date
                                                                        ) => {
                                                                            const startDate =
                                                                                getValues(
                                                                                    `job.${jobIndex}.startDate`
                                                                                );
                                                                            return (
                                                                                isNotEmpty(
                                                                                    startDate
                                                                                ) &&
                                                                                (moment(
                                                                                    date
                                                                                ).diff(
                                                                                    moment(
                                                                                        startDate
                                                                                    ),
                                                                                    "days"
                                                                                ) >=
                                                                                    0 ||
                                                                                    t(
                                                                                        "errorMsg.date.afterThisDate",
                                                                                        {
                                                                                            targetDate: `${moment(
                                                                                                startDate
                                                                                            ).format(
                                                                                                "DD/MM/YYYY"
                                                                                            )}`,
                                                                                        }
                                                                                    ))
                                                                            );
                                                                        },
                                                                },
                                                            }
                                                        ),
                                                    }}
                                                    type="dateTime"
                                                    dateFormat="dd/MM/yyyy h:mm aa"
                                                    onChange={() => {
                                                        trigger([
                                                            `job.${jobIndex}.startDate`,
                                                            `job.${jobIndex}.endDate`,
                                                        ]);
                                                    }}
                                                    minDate={new Date()}
                                                />
                                            </Grid>
                                            <Grid item xs={1}></Grid>
                                        </Grid>
                                    </Box>

                                    <div className={classes.isPublish}>
                                        <CustomCheckBox
                                            label={t("Form101.label.publish")}
                                            required={false}
                                            control={control}
                                            name={`job.${jobIndex}.isPublish`}
                                            boxStyle={{
                                                marginLeft: "-50px",
                                            }}
                                            onChange={(e) => {
                                                const jobList = getValues(
                                                    "job"
                                                )?.filter(
                                                    (job, index) =>
                                                        jobIndex !== index
                                                );
                                                const job = getValues(
                                                    `job.${jobIndex}`
                                                );
                                                if (
                                                    jobList?.find(
                                                        (publishJob) =>
                                                            publishJob?.isPublish ===
                                                                true &&
                                                            publishJob?.jobTitle ===
                                                                job?.jobTitle
                                                    ) &&
                                                    e.target.checked === true
                                                ) {
                                                    setValue(
                                                        `job.${jobIndex}.isPublish`,
                                                        false
                                                    );
                                                    const optionsList =
                                                        getValues(
                                                            `jobApplication${i18n.language?.toUpperCase()}`
                                                        );
                                                    const initJobOptions =
                                                        optionsList?.jobOptions ||
                                                        {};
                                                    const duplicatePublishJobText =
                                                        t(
                                                            "Form101.errorMsg.duplicatePublishJob",
                                                            {
                                                                duplicatePublishJob:
                                                                    initJobOptions?.[
                                                                        job
                                                                            ?.jobTitle
                                                                    ],
                                                            }
                                                        );
                                                    setDuplicatePublishJobText(
                                                        duplicatePublishJobText
                                                    );
                                                    setDuplicatePublishJobDialog(
                                                        true
                                                    );
                                                    return false;
                                                } else {
                                                    let newArr = [
                                                        ...disableArr,
                                                    ];
                                                    newArr[jobIndex] =
                                                        e.target.checked;
                                                    setDisableArr(newArr);
                                                }
                                            }}
                                        />
                                    </div>
                                    <div
                                        className={
                                            disableArr[jobIndex]
                                                ? classes.disable
                                                : ""
                                        }
                                    >
                                        <SubjectTable
                                            classes={classes}
                                            control={control}
                                            register={register}
                                            jobIndex={jobIndex}
                                            defaultValues={defaultValues}
                                            setValue={setValue}
                                            getValues={getValues}
                                            setDisablePostAddBtn={
                                                setDisablePostAddBtn
                                            }
                                        />
                                        <DailyStatistics
                                            classes={classes}
                                            control={control}
                                            register={register}
                                            errors={errors}
                                            jobIndex={jobIndex}
                                            setValue={setValue}
                                            getValues={getValues}
                                            defaultValues={defaultValues}
                                            reviewerList={reviewerList}
                                        />

                                        <Box mt={8}>
                                            <Divider />
                                        </Box>

                                        <Button
                                            className={classes.removeBtn}
                                            onClick={() => {
                                                handleRemoveList(jobIndex);
                                            }}
                                            variant="contained"
                                            color="primary"
                                        >
                                            {t("common.button.remove")}
                                        </Button>
                                    </div>
                                </Box>
                            </FormBox>
                        );
                    })}
                    <Box mt={6} style={{ textAlign: "right" }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleAppendList}
                            style={{
                                opacity: disablePostAddBtn ? 0.5 : 1,
                                pointerEvents: disablePostAddBtn
                                    ? "none"
                                    : "auto",
                            }}
                        >
                            {t("Form101.label.addJob")}
                        </Button>
                    </Box>
                </Box>
            </FormBox>
            <AlertDialog
                formOpen={duplicatePublishJobDialog}
                content={
                    <Typography
                        dangerouslySetInnerHTML={{
                            __html: duplicatePublishJobText,
                        }}
                    ></Typography>
                }
                confirmButton={{
                    action: () => {
                        setDuplicatePublishJobDialog(false);
                    },
                    label: t("common.confirm"),
                }}
            />
        </>
    );
}

export default ParameterTemplate101;
